export default [{
        path: '/appraise/batchReview',
        component: () =>
            import ('../../pages/appraise/batchReview/batchReview.vue'),
        meta: {
            title: '批量审核',
            keepAlive: true
        }
    },
    {
        path: '/appraise/tabBatch',
        component: () =>
            import ('../../pages/appraise/batchReview/tabBatch.vue'),
        meta: {
            title: '',
            keepAlive: true
        }
    }

]